/** The editor's mouse and keyboard controls, shown under the stage. */
const SHORTCUTS: readonly (readonly [string, string])[] = [
  ['Drag', 'move'],
  ['Handles', 'resize (Shift keeps 16:9)'],
  ['Alt', 'no snapping'],
  ['Arrows', 'nudge (Shift: 10 px)'],
  ['Ctrl+D', 'duplicate'],
  ['Del', 'remove'],
  ['Ctrl+Z', 'undo'],
  ['Ctrl+Y', 'redo'],
];

export function ShortcutList() {
  return (
    <ul className="shortcuts" aria-label="Editor shortcuts">
      {SHORTCUTS.map(([keys, what]) => (
        <li key={keys}>
          <kbd>{keys}</kbd> {what}
        </li>
      ))}
    </ul>
  );
}
